import {Snackbar,SnackbarProps} from '@mui/material';

export const SnackBar = (props:SnackbarProps) => {

  return (
      <Snackbar {...props} />
  );
}
